export default "__VITE_ASSET__Bir4EBvF__"